import React from 'react';
import { TrendingUpIcon, UsersIcon, ShoppingBagIcon, DollarSignIcon, ArrowUpIcon, ArrowDownIcon, BarChart3Icon, PieChartIcon } from 'lucide-react';
export const AdminDashboard = () => {
  // Sample data for the dashboard
  const stats = [{
    title: 'Total Sales',
    value: '$24,345',
    change: '+5.2%',
    isIncrease: true,
    period: 'vs last month',
    icon: <DollarSignIcon className="h-6 w-6 text-blue-600" data-id="element-1390" />
  }, {
    title: 'New Orders',
    value: '456',
    change: '+12.5%',
    isIncrease: true,
    period: 'vs last month',
    icon: <ShoppingBagIcon className="h-6 w-6 text-green-600" data-id="element-1391" />
  }, {
    title: 'Active Dealers',
    value: '48',
    change: '+2.1%',
    isIncrease: true,
    period: 'vs last month',
    icon: <UsersIcon className="h-6 w-6 text-purple-600" data-id="element-1392" />
  }, {
    title: 'Conversion Rate',
    value: '3.2%',
    change: '-0.4%',
    isIncrease: false,
    period: 'vs last month',
    icon: <TrendingUpIcon className="h-6 w-6 text-orange-600" data-id="element-1393" />
  }];
  const recentOrders = [{
    id: 'ORD-12345',
    customer: 'John Smith',
    date: '2023-05-15',
    amount: '$234.50',
    status: 'Completed'
  }, {
    id: 'ORD-12344',
    customer: 'Sarah Johnson',
    date: '2023-05-15',
    amount: '$129.99',
    status: 'Processing'
  }, {
    id: 'ORD-12343',
    customer: 'Michael Brown',
    date: '2023-05-14',
    amount: '$89.00',
    status: 'Completed'
  }, {
    id: 'ORD-12342',
    customer: 'Emma Wilson',
    date: '2023-05-14',
    amount: '$345.75',
    status: 'Shipped'
  }, {
    id: 'ORD-12341',
    customer: 'David Lee',
    date: '2023-05-13',
    amount: '$78.50',
    status: 'Completed'
  }];
  const topDealers = [{
    name: 'TechHub Singapore',
    sales: '$12,345',
    orders: 234,
    rating: 4.8
  }, {
    name: 'Mobile Masters',
    sales: '$10,234',
    orders: 198,
    rating: 4.7
  }, {
    name: 'Gadget World',
    sales: '$8,456',
    orders: 156,
    rating: 4.5
  }, {
    name: 'Phone Paradise',
    sales: '$7,890',
    orders: 145,
    rating: 4.6
  }, {
    name: 'Digital Dreams',
    sales: '$6,543',
    orders: 123,
    rating: 4.4
  }];
  return <div className="space-y-6" data-id="element-1394">
      <div className="flex justify-between items-center" data-id="element-1395">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1396">Dashboard</h1>
        <div className="flex space-x-3" data-id="element-1397">
          <select className="border border-gray-300 rounded-md shadow-sm py-2 px-3 bg-white focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-1398">
            <option data-id="element-1399">Last 7 days</option>
            <option data-id="element-1400">Last 30 days</option>
            <option data-id="element-1401">This month</option>
            <option data-id="element-1402">Last month</option>
            <option data-id="element-1403">This year</option>
          </select>
          <button className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors" data-id="element-1404">
            Export
          </button>
        </div>
      </div>
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1405">
        {stats.map((stat, index) => <div key={index} className="bg-white rounded-lg shadow-sm p-6 border border-gray-200" data-id="element-1406">
            <div className="flex justify-between items-start" data-id="element-1407">
              <div data-id="element-1408">
                <p className="text-sm font-medium text-gray-500" data-id="element-1409">
                  {stat.title}
                </p>
                <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-1410">
                  {stat.value}
                </p>
              </div>
              <div className="p-3 rounded-full bg-gray-50" data-id="element-1411">{stat.icon}</div>
            </div>
            <div className="flex items-center mt-4" data-id="element-1412">
              <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${stat.isIncrease ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-1413">
                {stat.isIncrease ? <ArrowUpIcon className="h-3 w-3 mr-1" data-id="element-1414" /> : <ArrowDownIcon className="h-3 w-3 mr-1" data-id="element-1415" />}
                {stat.change}
              </span>
              <span className="text-xs text-gray-500 ml-2" data-id="element-1416">{stat.period}</span>
            </div>
          </div>)}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1417">
        {/* Charts */}
        <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200" data-id="element-1418">
          <div className="flex justify-between items-center mb-6" data-id="element-1419">
            <h2 className="text-lg font-medium text-gray-900" data-id="element-1420">
              Sales Overview
            </h2>
            <button className="text-gray-400 hover:text-gray-500" data-id="element-1421">
              <BarChart3Icon className="h-5 w-5" data-id="element-1422" />
            </button>
          </div>
          {/* Placeholder for chart */}
          <div className="h-64 bg-gray-50 rounded-lg flex items-center justify-center" data-id="element-1423">
            <p className="text-gray-400" data-id="element-1424">Sales Chart Placeholder</p>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200" data-id="element-1425">
          <div className="flex justify-between items-center mb-6" data-id="element-1426">
            <h2 className="text-lg font-medium text-gray-900" data-id="element-1427">
              Revenue by Category
            </h2>
            <button className="text-gray-400 hover:text-gray-500" data-id="element-1428">
              <PieChartIcon className="h-5 w-5" data-id="element-1429" />
            </button>
          </div>
          {/* Placeholder for chart */}
          <div className="h-64 bg-gray-50 rounded-lg flex items-center justify-center" data-id="element-1430">
            <p className="text-gray-400" data-id="element-1431">Category Chart Placeholder</p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1432">
        {/* Recent Orders */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-1433">
          <div className="px-6 py-4 border-b border-gray-200" data-id="element-1434">
            <h2 className="text-lg font-medium text-gray-900" data-id="element-1435">Recent Orders</h2>
          </div>
          <div className="overflow-x-auto" data-id="element-1436">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-1437">
              <thead className="bg-gray-50" data-id="element-1438">
                <tr data-id="element-1439">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1440">
                    Order ID
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1441">
                    Customer
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1442">
                    Date
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1443">
                    Amount
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1444">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-1445">
                {recentOrders.map(order => <tr key={order.id} className="hover:bg-gray-50" data-id="element-1446">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600" data-id="element-1447">
                      {order.id}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-1448">
                      {order.customer}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1449">
                      {order.date}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-1450">
                      {order.amount}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1451">
                      <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${order.status === 'Completed' ? 'bg-green-100 text-green-800' : order.status === 'Processing' ? 'bg-yellow-100 text-yellow-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-1452">
                        {order.status}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <div className="px-6 py-4 border-t border-gray-200" data-id="element-1453">
            <a href="#" className="text-sm font-medium text-blue-600 hover:text-blue-500" data-id="element-1454">
              View all orders
            </a>
          </div>
        </div>
        {/* Top Dealers */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-1455">
          <div className="px-6 py-4 border-b border-gray-200" data-id="element-1456">
            <h2 className="text-lg font-medium text-gray-900" data-id="element-1457">Top Dealers</h2>
          </div>
          <div className="overflow-x-auto" data-id="element-1458">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-1459">
              <thead className="bg-gray-50" data-id="element-1460">
                <tr data-id="element-1461">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1462">
                    Dealer
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1463">
                    Sales
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1464">
                    Orders
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1465">
                    Rating
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-1466">
                {topDealers.map((dealer, index) => <tr key={index} className="hover:bg-gray-50" data-id="element-1467">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1468">
                      {dealer.name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-1469">
                      {dealer.sales}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1470">
                      {dealer.orders}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-1471">
                      {dealer.rating}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <div className="px-6 py-4 border-t border-gray-200" data-id="element-1472">
            <a href="#" className="text-sm font-medium text-blue-600 hover:text-blue-500" data-id="element-1473">
              View all dealers
            </a>
          </div>
        </div>
      </div>
    </div>;
};